import { render, staticRenderFns } from "./CostumersUpload.vue?vue&type=template&id=3fec0357&scoped=true&"
import script from "./CostumersUpload.vue?vue&type=script&lang=js&"
export * from "./CostumersUpload.vue?vue&type=script&lang=js&"
import style0 from "./CostumersUpload.vue?vue&type=style&index=0&id=3fec0357&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fec0357",
  null
  
)

export default component.exports